module.exports = __webpack_public_path__ + "static/media/bg2.b0ef06bf.jpg";